var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"page-header d-print-none"},[_c('div',{class:{ container: _vm.noContainer === false }},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }